const summarySteps= [
    {
      content: <h2>Let's begin !</h2>,
      locale: { skip: <strong>SKIP</strong> },
      placement: "center",
      target: "body"
    },
    {
      content: <h2>You can directly click on the survey title to edit it.</h2>,
      placement: "bottom",
      target: "#surveyDetailSurveyTitleUpdate",
      title: "First step"
    },
    {
      content: <h2>By clicking on the tabs shown in this area, you can access different sections of the survey detail page.</h2>,
      placement: "bottom",
      target: "#surveyDetailNavbar",
      title: "Second step"
    },
    {
      content: <h2>The two graphs you see here show, in order, the range of completion times for the survey and the completion percentage by the users who received the survey.</h2>,
      placement: "bottom",
      target: "#surveySummaryGraphs",
      title: "Third step"
    },
    {
      content: <h2>In this section, you can access summary information related to the survey and refresh the summary page instantly using the icon located at the top-right corner. At the bottom of this section, you can reset the survey. This will reset all the values entered for the survey, along with the responses and any reports generated as a result of the responses.</h2>,
      placement: "left",
      target: "#summaryDrawerBody",
      title: "Fourth step"
    },
  ]
  export default summarySteps;